import { Outlet, useLocation } from 'react-router-dom';
import { PrimaryNav } from '@/layouts/PrimaryNav';
import { LearningSessionStatusDock } from '@/components/learning-sessions/LearningSessionStatusDock';
import { LearningSessionProvider } from '@/providers/LearningSessionProvider';
import { useContractSigningNavHidden } from '@/hooks/useContractSigningNavHidden';

const COURSE_HUB_PATTERN =
  /^\/courses\/(?!create$)[^/]+(\/(builder|preview|horas-sesion|foro(\/[^/]+)?))?$|^\/calificaciones\/curso\/[^/]+$|^\/mis-cursos\/[^/]+(\/(calificaciones|foro(\/[^/]+)?))?$/;
const COURSE_PLAY_PATTERN =
  /^\/courses\/[^/]+\/(play\/[^/]+|items\/[^/]+\/play)$|^\/mis-cursos\/[^/]+\/play\/[^/]+$/;

const ASSESSMENT_SHOW_PATTERN = /^\/evaluaciones\/(?!create$|intentos\/)[^/]+$/;
const QUIZ_ATTEMPT_PATTERN = /^\/evaluaciones\/intentos\/[^/]+$|^\/evaluaciones\/[^/]+\/preview$/;
const CONTRACT_DETAIL_PATTERN = /^\/mis-contratos\/[^/]+$/;

export function AppLayout() {
  const { pathname, search } = useLocation();
  const courseHub = COURSE_HUB_PATTERN.test(pathname);
  const assessmentShow = ASSESSMENT_SHOW_PATTERN.test(pathname);
  const quizAttempt = QUIZ_ATTEMPT_PATTERN.test(pathname);
  const contractDetail = CONTRACT_DETAIL_PATTERN.test(pathname);
  const examFocus =
    /^\/examen-practico\/(?!nuevo$)[^/]+$/.test(pathname) &&
    new URLSearchParams(search).get('modo') === 'examen';
  const hidePrimaryNav = useContractSigningNavHidden() || examFocus;
  const fullBleed =
    examFocus ||
    courseHub ||
    assessmentShow ||
    quizAttempt ||
    contractDetail ||
    COURSE_PLAY_PATTERN.test(pathname);

  return (
    <LearningSessionProvider>
      <div className="flex min-h-screen flex-col">
        {!hidePrimaryNav ? <PrimaryNav /> : null}
        <main
          className={`lms-site-admin-page moodle-page-main flex-1 bg-dash-surface ${hidePrimaryNav ? '' : 'lms-main-with-nav'} ${courseHub ? 'lms-course-hub-main' : ''}`}
        >
          {fullBleed ? (
            <Outlet />
          ) : (
            <div className="lms-site-admin-hub-container py-8 md:py-12">
              <Outlet />
            </div>
          )}
        </main>
        {examFocus ? null : <LearningSessionStatusDock />}
      </div>
    </LearningSessionProvider>
  );
}
